import { useRouterHistory } from 'react-router';
import { createHistory } from 'history';
import { routerMiddleware } from 'react-router-redux';

export const routerHistory = useRouterHistory(createHistory)();

export const middlewareHistory = routerMiddleware(routerHistory);



// WEBPACK FOOTER //
// ./book/src/commons/routes/routerHistoryConfig.js